// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: '3c9a3d44-a13a-4120-a373-d1056a4c52b8',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: -61,
      y: -69,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Bird_House_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'd8e554ee-e607-4fd0-a1f6-9556ede8251e',
      type: 'Container',
      runtimeType: null,
      name: 'birdHouse',
      className: '',
      x: 0,
      y: -10,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'd605fcdd-5707-4c87-949c-5a6dccb8a5a0',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 1,
      y: 23,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Bird_House_Inside',
      parent: 'd8e554ee-e607-4fd0-a1f6-9556ede8251e',
      data: undefined,
      stateByName: {}
    },
    {
      id: '40cf523d-54fe-4e1b-ae2a-0d2431755cd7',
      type: 'Sprite',
      runtimeType: null,
      name: 'rightDoor',
      className: '',
      x: 0,
      y: 16,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Bird_House_Right_Door',
      parent: 'd8e554ee-e607-4fd0-a1f6-9556ede8251e',
      data: undefined,
      stateByName: {
        'doors-opened': {
          x: 15
        }
      }
    },
    {
      id: '26f9489f-5c0a-4185-a312-83cca8f5c03e',
      type: 'Sprite',
      runtimeType: null,
      name: 'leftDoor',
      className: '',
      x: 0,
      y: 16,
      anchor: {
        x: 1,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Bird_House_Left_Door',
      parent: 'd8e554ee-e607-4fd0-a1f6-9556ede8251e',
      data: undefined,
      stateByName: {
        'doors-opened': {
          x: -15
        }
      }
    },
    {
      id: 'f30fb8ee-5b42-42c7-97eb-2e72595a115d',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 1,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Bird_House',
      parent: 'd8e554ee-e607-4fd0-a1f6-9556ede8251e',
      data: undefined,
      stateByName: {}
    },
    {
      id: '0eb0a5ad-10e2-4367-8158-424cf0d9fd0f',
      type: 'Sprite',
      runtimeType: null,
      name: 'birdHead',
      className: '',
      x: -1,
      y: 26,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Bird_Head',
      parent: 'd8e554ee-e607-4fd0-a1f6-9556ede8251e',
      data: undefined,
      stateByName: {
        'doors-opened': {
          visible: true
        }
      }
    },
    {
      id: '618f9c46-9dfb-4ded-bbd0-9f8198d2e639',
      type: 'Sprite',
      runtimeType: null,
      name: 'whiteOverlay',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Bird_House_White',
      parent: 'd8e554ee-e607-4fd0-a1f6-9556ede8251e',
      data: undefined,
      stateByName: {}
    },
    {
      id: '30832f9a-ac4f-4395-9750-77e1b6fcbf60',
      type: 'Sprite',
      runtimeType: null,
      name: 'doorHandle',
      className: '',
      x: 0,
      y: 11,
      anchor: {
        x: 0.4,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Bird_House_Door_Handle',
      parent: '26f9489f-5c0a-4185-a312-83cca8f5c03e',
      data: undefined,
      stateByName: {
        'doors-opened': {
          angle: -90
        }
      }
    }
  ],
  version: '1.0.0',
  stateNames: [
    'doors-closed',
    'doors-opened'
  ],
  animations: []
} as const;

export class BirdHouseBlockerLayout {
  static raw = raw;
  root: Container;
  birdHouse: Container;
  rightDoor: Sprite;
  leftDoor: Sprite;
  birdHead: Sprite;
  whiteOverlay: Sprite;
  doorHandle: Sprite;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: 'doors-closed' | 'doors-opened';
    ModelByName: {
      root: typeof raw['list'][0];
      birdHouse: typeof raw['list'][2];
      rightDoor: typeof raw['list'][4];
      leftDoor: typeof raw['list'][5];
      birdHead: typeof raw['list'][7];
      whiteOverlay: typeof raw['list'][8];
      doorHandle: typeof raw['list'][9];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
